import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import PurchaseOrderGrid from '../../../features/distributor/purchase-order-grid/components/PurchaseOrderGrid';

export default function PurchaseOrdersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Purchase Orders')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<PurchaseOrderGrid />
			</div>
		</React.Fragment>
	)
} 
